import { Reveal, MaskLines, Label, PartialCircle } from "./Reveal-graphics";
import WaitlistForm from "./WaitlistForm";

export default function FirstRelease() {
  return (
    <section id="join" className="relative bg-forest text-paper py-16 md:py-20 overflow-hidden" data-testid="first-release-section">
      <PartialCircle className="absolute -right-36 -top-36 w-[440px] md:w-[600px] text-paper opacity-[0.07] pointer-events-none" />
      <PartialCircle className="absolute -left-40 -bottom-44 w-[400px] md:w-[540px] text-paper opacity-[0.05] pointer-events-none" />

      <div className="relative max-w-3xl mx-auto px-6 md:px-10 text-center">
        <Label light>05 — The first release</Label>

        <h2 className="mt-10 font-serif font-normal text-paper text-4xl sm:text-5xl lg:text-6xl leading-[1.1] tracking-[-0.005em]">
          <MaskLines
            lines={[
              <em key="i" className="italic text-paper/85">Be the first to know as new chapters get written.</em>,
            ]}
          />
        </h2>

        <Reveal delay={0.25}>
          <p className="mt-9 text-base md:text-lg leading-relaxed text-paper/80 max-w-xl mx-auto" data-testid="first-release-copy">
            As our coffee takes shape. Join the Anichya List for news about upcoming releases,
            new origins and the coffees and forests we are exploring.
          </p>
        </Reveal>

        <Reveal delay={0.35} className="mt-12 max-w-md mx-auto text-left">
          <WaitlistForm
            placeholder="Your email address"
            buttonLabel="Join the list"
            note="Occasional notes about new coffees, origins and releases. No noise."
            dark
            testid="first-release-signup"
          />
        </Reveal>
      </div>
    </section>
  );
}
